export default __webpack_public_path__ + "static/media/10.c5e78274.jpeg";